// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"be998e83","559":"31e30a79"}[chunkId] + ".chunk.js";
};